<div class="client-datafeed-container">
  <h3>Security Exports</h3>

  <div *ngIf="loading">Loading exports...</div>
  <div *ngIf="error" class="error">{{ error }}</div>

  <button class="btn btn-primary mb-2" (click)="addExport()">Add Security Export</button>

  <div class="feed-card" *ngFor="let se of exports">
    <div class="feed-header" (click)="se.editing = !se.editing">
      <span>{{ se.name || '(Unnamed Export)' }}</span>

      <span class="actions">
        <ng-container *ngIf="!se.editing">
          <button class="btn btn-sm btn-warning edit"
                  (click)="editExport(se); $event.stopPropagation()">
            Edit
          </button>

          <button class="btn btn-sm btn-success"
                  (click)="runNow(se); $event.stopPropagation()">
            Run Now
          </button>

          <button class="btn btn-sm btn-danger"
                  (click)="deleteExport(se); $event.stopPropagation()">
            Delete
          </button>
        </ng-container>
      </span>
    </div>

    <div class="feed-edit" *ngIf="se.editing">
      <div class="edit-section">

        <label>
          Name:
          <input type="text" [(ngModel)]="se.name" />
        </label>

        <label>
          Enabled:
          <input type="checkbox" [(ngModel)]="se.enabled" />
        </label>

        <label>
          Auto Run:
          <input type="checkbox" [(ngModel)]="se.autoRun" />
        </label>

        <label>
          View:
          <input type="text" [(ngModel)]="se.view" placeholder="dbo.MyView" />
        </label>

        <label>
          Export File Name:
          <input type="text" [(ngModel)]="se.exportFileName" placeholder="ExportFile.csv" />
        </label>

        <label>
          Date Format:
          <select [(ngModel)]="se.dateFormat">
            <option [ngValue]="''">-- Select Date Format --</option>
            <option *ngFor="let fmt of dateFormats" [ngValue]="fmt">
              {{ fmt }}
            </option>
          </select>
        </label>

        <label>
          Connection:
          <select [(ngModel)]="se.dataSourceId">
            <option [ngValue]="''">-- None (email only) --</option>
            <option *ngFor="let ds of dataSources" [ngValue]="ds.DataSourceId">
              {{ ds.name }}
            </option>
          </select>
          <span *ngIf="dataSources.length === 0" class="no-connections">No file connections available.</span>
        </label>

        <div class="recipients-section">
          <span class="recipients-label">Recipients:</span>
          <div class="email-list">
            <div class="email-row" *ngFor="let r of se.recipients; let i = index; trackBy: trackByIndex">
              <input type="email" placeholder="name@example.com" [(ngModel)]="se.recipients![i]" />
              <button type="button" class="btn btn-sm btn-danger" (click)="removeRecipient(se, i)">&times;</button>
            </div>
            <button type="button" class="btn btn-sm btn-secondary" (click)="addRecipient(se)">Add Recipient</button>
          </div>
        </div>

        <!--<label>
          Schedule Cron:
          <input type="text" [(ngModel)]="se.schedule" placeholder="0 0 * * *" />
        </label>-->

      </div>

      <div class="edit-actions">
        <button class="save" (click)="saveExport(se)">Save</button>
        <button class="cancel" (click)="cancelEdit(se)">Cancel</button>
      </div>
    </div>
  </div>
</div>
